import React from 'react';

/**
 * StudyStatCards — Grid de stat cards para resumo numérico do estudo
 *
 * Props:
 *   stats — Array de { value, label, icon?, color? }
 *   columns — Número de colunas (default: 4)
 */
const StudyStatCards = ({ stats = [], columns = 4 }) => {
  if (!stats.length) return null;

  const gridCols = {
    2: 'grid-cols-2',
    3: 'grid-cols-1 sm:grid-cols-3',
    4: 'grid-cols-2 sm:grid-cols-4',
    5: 'grid-cols-2 sm:grid-cols-5',
  };

  return (
    <div className={`grid ${gridCols[columns] || 'grid-cols-2 sm:grid-cols-4'} gap-4`}>
      {stats.map((s, i) => (
        <div
          key={i}
          className="bg-white rounded-xl border border-gray-200 p-4 text-center hover:shadow-sm transition-shadow"
        >
          {s.icon && <div className="text-2xl mb-1">{s.icon}</div>}
          <div
            className="text-2xl font-black"
            style={{ color: s.color || '#111111' }}
          >
            {typeof s.value === 'number' ? s.value.toLocaleString('pt-BR') : s.value}
          </div>
          <div className="text-xs text-gray-500 mt-1 font-medium">{s.label}</div>
        </div>
      ))}
    </div>
  );
};

export default StudyStatCards;
